import React from 'react';
import { motion } from 'framer-motion';

const Schedule: React.FC = () => {
  const events = [
    {
      time: '2:30 PM',
      title: 'Guest Arrival',
      description: 'Welcome drinks and mingling'
    },
    {
      time: '3:00 PM',
      title: 'Wedding Ceremony',
      description: 'The main event - we tie the knot!'
    },
    {
      time: '3:30 PM',
      title: 'Confetti & Photos',
      description: 'Celebration photos with family and friends'
    },
    {
      time: '4:00 PM',
      title: 'Cocktail Hour',
      description: 'Drinks and canapés in the garden'
    },
    {
      time: '6:00 PM',
      title: 'Wedding Breakfast',
      description: 'Three-course meal and speeches'
    },
    {
      time: '8:30 PM',
      title: 'First Dance',
      description: 'Dancing begins'
    },
    {
      time: '9:00 PM',
      title: 'Party Time',
      description: 'Dancing, drinks, and celebration until late'
    },
    {
      time: '12:00 AM',
      title: 'Carriages',
      description: 'Time to go home...'
    }
  ];

  return (
    <div className="bg-gradient-to-br from-cream via-white to-blush py-12 px-4" style={{ minHeight: '100vh', paddingBottom: '20vh' }}>
      <div className="max-w-4xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-center mb-12"
        >
          <h1 className="page-header text-charcoal mb-4">
            Schedule
          </h1>
          <p className="body-text text-gray-light">
            Here's how our special day will unfold
          </p>
        </motion.div>

        <div className="space-y-6">
          {events.map((event, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, x: -30 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: index * 0.1 }}
              className="bg-white/80 backdrop-blur-sm rounded-lg p-6 shadow-lg"
            >
              <div className="text-center">
                <div className="mb-4">
                  <div className="section-header text-gold">
                    {event.time}
                  </div>
                </div>
                <div>
                  <h3 className="subheading text-charcoal mb-2">
                    {event.title}
                  </h3>
                  <p className="body-text text-gray-light">
                    {event.description}
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Schedule;